import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MenuPage } from '../menu/menu'
import { SlideContentPage } from '../slidecontent/slidecontent'
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the SearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {
  keyword: String;
  result: any[] = [];
  token: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private storage: Storage
  ) {
    this.result = [];
  }

  async ngOnInit() {
    this.token = await this.storage.get('token');
  }

  search() {
    this.result = [];


    this.http
    .post(this.appConfig.apiUrl() + 'index.php/api/search/item', {
      token: this.token,
      keyword: this.keyword,
      app_key: this.appConfig.appKey()
    })
    .subscribe(
      (res: any) => {
        let data = res.result;

        if (data) {
          for (let result of data) {
            let temp = {
              id: result.id,
              title: result.name,
              type: result.type,
              background: result.feature_image
            };
            this.result.push(temp);
          }
        } else {
          this.result = [];
        }

        console.log(this.result);
      },
      err => {
        console.log('Error request' + JSON.stringify(err));
      }
    );
  }

  openItem(item) {
    console.log(item);
    if (item.type == 'portfolio') {
      this.navCtrl.push(MenuPage, {
        portfolio_title: item.title,
        portfolio_id: item.id,
        header_img: item.background
      });
    }

    if (item.type == 'subportfolio') {
      this.navCtrl.push(SlideContentPage, {
        subportfolio_id: item.id,
        img: item.background,
        title: item.title
      });
    }

    // if (item.type == 'content') {
    //   this.navCtrl.push(SlideContentPage, {
    //     subportfolio_id: item.id,
    //     img: item.background,
    //     title: item.title
    //   });
    // }
  }

}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts